if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

(() => {
  const measurementTable = document.querySelector('.ns-size-guide-table--measurements');
  const measurementTab = document.querySelector('.ns-size-guide-tab[data-tab="measurements"]');
  const measurementPane = document.querySelector('.ns-size-guide-pane[data-pane="measurements"]');

  if (!measurementTable || !measurementTab || !measurementPane) return;

  const isJapanese = document.documentElement.lang.toLowerCase().startsWith('ja');

  const labels = isJapanese
    ? {
        sizeGuide: 'サイズガイド',
        measurements: '商品寸法',
        centimeters: 'センチメートル',
        inches: 'インチ',
        measurement: '寸法',
        close: 'サイズガイドを閉じる',
        tabs: 'サイズガイドのタブ',
        note: '記載された寸法は完成した商品の実寸です。生産工程により若干の個体差が生じる場合があります。',
      }
    : {
        sizeGuide: 'Size guide',
        measurements: 'Measurements',
        centimeters: 'Centimeters',
        inches: 'Inches',
        measurement: 'Measurement',
        close: 'Close size guide',
        tabs: 'Size guide tabs',
        note: 'Measurements refer to the finished garment. Minor differences may occur depending on production.',
      };

  const rowLabels = isJapanese
    ? {
        'Centre-back length': '後中心丈',
        'Shoulder width': '肩幅',
        'Chest circumference': '胸囲',
        'Waist circumference': 'ウエスト囲',
        'Hip circumference': 'ヒップ囲',
        'Length, including waistband': '総丈（ウエストベルト含む）',
        'Front rise': '前股上',
        'Back rise': '後股上',
        'Hem circumference': '裾囲',
        'Sleeve length': '袖丈',
        'Sleeve-opening circumference': '袖口囲',
        'Back length, measured below collar': '後丈（襟下から）',
      }
    : {};

  const sizeGuideTab = document.querySelector('.ns-size-guide-tab[data-tab="size-guide"]');
  const centimetersToggle = measurementPane.querySelector('.ns-unit-toggle[data-unit="cm"]');
  const inchesToggle = measurementPane.querySelector('.ns-unit-toggle[data-unit="in"]');
  const panel = document.getElementById('ns-size-guide-panel');
  const closeButton = document.querySelector('.ns-size-guide-close');
  const tabList = document.querySelector('.ns-size-guide-tabs');
  const sizeTableHeading = document.querySelector('.ns-size-guide-table--size thead th:first-child');

  if (sizeGuideTab) sizeGuideTab.textContent = labels.sizeGuide;
  measurementTab.textContent = labels.measurements;
  if (centimetersToggle) centimetersToggle.textContent = labels.centimeters;
  if (inchesToggle) inchesToggle.textContent = labels.inches;
  if (panel) panel.setAttribute('aria-label', labels.sizeGuide);
  if (closeButton) closeButton.setAttribute('aria-label', labels.close);
  if (tabList) tabList.setAttribute('aria-label', labels.tabs);
  if (sizeTableHeading && isJapanese) sizeTableHeading.textContent = 'サイズ';

  const guides = {
    TEE001: {
      sizes: ['M', 'L'],
      rows: [
        ['Centre-back length', [46.4, 47.1]],
        ['Shoulder width', [35.2, 36.2]],
        ['Chest circumference', [76.3, 81.4]],
        ['Waist circumference', [70.7, 75.8]],
      ],
    },
    SKT001: {
      sizes: ['S', 'M', 'L'],
      rows: [
        ['Centre-back length', [34.4, 35.1, 35.8]],
        ['Waist circumference', [70, 74, 78]],
        ['Hip circumference', [96, 100, 104]],
      ],
    },
    SKT002: {
      sizes: ['S', 'M', 'L'],
      rows: [
        ['Length, including waistband', [31, 31.5, 32.5]],
        ['Waist circumference', [68, 72, 76]],
        ['Hip circumference', [96.3, 100.1, 104.1]],
      ],
    },
    TRS001: {
      sizes: ['S', 'M', 'L'],
      rows: [
        ['Length, including waistband', [59.2, 59.2, 59.2]],
        ['Waist circumference', [74.5, 78, 82]],
        ['Hip circumference', [98.5, 102, 105.8]],
        ['Front rise', [26.7, 27.1, 28]],
        ['Back rise', [38.2, 38.6, 39.3]],
        ['Hem circumference', [57.1, 58.1, 59.5]],
      ],
    },
    JKT001: {
      sizes: ['M', 'L'],
      rows: [
        ['Centre-back length', [60, 62]],
        ['Shoulder width', [41, 43]],
        ['Chest circumference', [94, 101]],
        ['Waist circumference', [96, 104]],
        ['Hem circumference', [106, 116]],
        ['Sleeve length', [46, 49]],
        ['Sleeve-opening circumference', [59, 61]],
      ],
    },
    JKT002: {
      sizes: ['S', 'M', 'L'],
      rows: [
        ['Centre-back length', [62.3, 63.8, 65.8]],
        ['Shoulder width', [41, 42, 43]],
        ['Chest circumference', [104, 108, 112]],
        ['Waist circumference', [100, 104, 108]],
        ['Hem circumference', [99.9, 103.9, 107.9]],
        ['Sleeve length', [58, 59.5, 61.5]],
        ['Sleeve-opening circumference', [26, 27, 28]],
      ],
    },
    DRS001: {
      sizes: ['ONE'],
      rows: [
        ['Centre-back length', [62.4]],
        ['Chest circumference', [78]],
        ['Waist circumference', [66]],
      ],
    },
    BLS002: {
      sizes: ['M', 'L'],
      rows: [
        ['Centre-back length', [53.1, 56.1]],
        ['Chest circumference', [98, 102]],
        ['Waist circumference', [86, 90]],
      ],
    },
    SHT002: {
      sizes: ['S', 'M', 'L'],
      rows: [
        ['Back length, measured below collar', [54.1, 56.1, 58.1]],
        ['Shoulder width', [39, 40, 41]],
        ['Chest circumference', [90, 94, 98]],
        ['Waist circumference', [83.9, 87.9, 91.9]],
      ],
    },
    SHT001: {
      sizes: ['M', 'L'],
      rows: [
        ['Centre-back length', [54, 56]],
        ['Shoulder width', [40, 41]],
        ['Chest circumference', [97, 101]],
        ['Waist circumference', [84, 88]],
      ],
    },
  };

  const handleMap = {
    'draped-jersey-tee': 'TEE001',
    'draped-jersey-top': 'TEE001',
    'mini-balloon-skirt-in-japanese-dot-fabric': 'SKT001',
    'mini-balloon-skirt-japanese-dot-fabric': 'SKT001',
    'layered-mini-skort': 'SKT002',
    'relaxed-crease-bermuda-shorts': 'TRS001',
    'contour-pleat-denim-jacket': 'JKT001',
    'contour-pleated-denim-jacket': 'JKT001',
    'relaxed-crease-blazer': 'JKT002',
    'asym-hem-jersey-mini-dress': 'DRS001',
    'asymmetrical-hem-jersey-mini-dress': 'DRS001',
    'boat-neck-top-in-japanese-dot-fabric': 'BLS002',
    'boat-neck-top-japanese-dot-fabric': 'BLS002',
    'square-neck-shirt-jacket': 'SHT002',
    'folded-collar-shirt': 'SHT001',
  };

  const titleMap = {
    'draped jersey tee': 'TEE001',
    'mini balloon skirt in japanese dot fabric': 'SKT001',
    'layered mini skort': 'SKT002',
    'relaxed crease bermuda shorts': 'TRS001',
    'contour pleat denim jacket': 'JKT001',
    'contour pleated denim jacket': 'JKT001',
    'relaxed crease blazer': 'JKT002',
    'asym hem jersey mini dress': 'DRS001',
    'boat neck top in japanese dot fabric': 'BLS002',
    'square neck shirt jacket': 'SHT002',
    'folded collar shirt': 'SHT001',
  };

  function resolveGuideKey() {
    const variantData = document.querySelector('variant-selects [data-selected-variant]');
    let sku = '';

    if (variantData) {
      try {
        sku = String(JSON.parse(variantData.textContent || '{}').sku || '').toUpperCase();
      } catch (error) {
        sku = '';
      }
    }

    const skuKeys = Object.keys(guides);
    const skuMatch = skuKeys.find((key) => sku.includes(key));
    if (skuMatch) return skuMatch;

    const productMarker = '/products/';
    const markerIndex = window.location.pathname.indexOf(productMarker);
    const handle = markerIndex === -1
      ? ''
      : window.location.pathname.slice(markerIndex + productMarker.length).split('/')[0].toLowerCase();

    if (handleMap[handle]) return handleMap[handle];

    const title = document.querySelector('.product__title h1')?.textContent.trim().toLowerCase() || '';
    return titleMap[title] || '';
  }

  const guide = guides[resolveGuideKey()];

  if (!guide) {
    measurementTab.hidden = true;
    measurementPane.hidden = true;
    return;
  }

  const head = document.createElement('thead');
  const headRow = document.createElement('tr');
  const measurementHeading = document.createElement('th');
  measurementHeading.textContent = labels.measurement;
  headRow.appendChild(measurementHeading);

  guide.sizes.forEach((size) => {
    const sizeHeading = document.createElement('th');
    sizeHeading.textContent = size;
    headRow.appendChild(sizeHeading);
  });

  head.appendChild(headRow);

  const body = document.createElement('tbody');

  guide.rows.forEach(([label, values]) => {
    const row = document.createElement('tr');
    const rowHeading = document.createElement('th');
    rowHeading.textContent = rowLabels[label] || label;
    row.appendChild(rowHeading);

    values.forEach((value) => {
      const cell = document.createElement('td');
      cell.dataset.cm = String(value);
      cell.dataset.in = (Number(value) / 2.54).toFixed(1);
      cell.textContent = String(value);
      row.appendChild(cell);
    });

    body.appendChild(row);
  });

  measurementTable.replaceChildren(head, body);

  const note = measurementPane.querySelector('.ns-size-guide-note');
  if (note) note.textContent = labels.note;
})();